const convertMillisecondsToTimeRemaining = (milliseconds) => {
    let timeRemaining = '';
    const minutes = Math.floor(milliseconds / 60000);
    const seconds = Math.floor((milliseconds % 60000) / 1000);
    if (minutes > 0) {
        if (minutes === 1) {
            timeRemaining += `${minutes} minute`;
        }
        else {
            timeRemaining += `${minutes} minutes`;
        }
    }
    if (minutes > 0 && seconds > 0) {
        timeRemaining += ' and ';
    }
    if (seconds > 0) {
        if (seconds === 1) {
            timeRemaining += `${seconds} second`;
        }
        else {
            timeRemaining += `${seconds} seconds`;
        }
    }
    return timeRemaining;
};
export default convertMillisecondsToTimeRemaining;
